import styled, { keyframes } from 'styled-components/macro'

export const AnimationLoop = keyframes`
  from {
    transform:translateX(0);
  }
  to{
    transform:translateX(-100%);
  }
`

export const PartnerLogosContainer = styled.div`
  display: ${(props) => (props.newPlayerPage ? 'block !important' : 'none')};
  height: ${(props) => (props.newPlayerPage ? '90px' : '140px')};
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  margin: 100px 0 20px 0;
  @media (min-width: 1024px) {
    display: ${(props) => (props.showPartnerLogos ? 'block' : 'none')};
  }
`

export const PartnerLogosContainerInner = styled.div`
  height: 100%;
  display: inline-flex;
  flex-direction: row;
  animation: ${AnimationLoop} 47s linear infinite;
`

export const PartnerLogo = styled.a`
  display: inline-flex;
  padding: 0 25px;
  filter: grayscale(1);
  opacity: 0.9;
  transition: filter 0.14s, opacity 0.14s;
  img {
    height: 100%;
  }
  &:hover {
    filter: grayscale(${(props) => (props.newPlayerPage ? 1 : 0)});
    opacity: ${(props) => (props.newPlayerPage ? 0.9 : 1)};
    transition: filter 0.14s, opacity 0.14s;
  }
  @media (min-width: 650px) {
    padding: 0 65px;
  }
`
